// Actions
export const addPacketDetails = (etchPacketEid, packetDetails) => {
    return {
      type: 'ADD_PACKET_DETAILS',
      payload: { etchPacketEid, packetDetails }
    };
};
  
  export const removePacketDetails = (etchPacketEid) => {
    return {
      type: 'REMOVE_PACKET_DETAILS',
      payload: etchPacketEid
    };
  };

  export const setPacketDetails = (etchPacketEid, packetDetails) => {
    return {
        type: 'SET_PACKET_DETAILS',
        payload: { etchPacketEid, packetDetails }
    }
}

export const voidPacketDetails = (eid) => {
    return {
      type: 'VOID_PACKET_DETAILS',
      payload: {
        eid,
      },
    };
  };


// AMEND EXTEND ACTIONS
// Action Types
const SET_CONTRACTS = 'SET_CONTRACTS';
const SET_STEP = 'SET_STEP';
const SET_FORMID = 'SET_FORMID'; 
const SET_AMENDMENTID = 'SET_AMENDMENTID'; 
const SET_FULLFORM = 'SET_FULLFORM'; 
const SET_AMENDMENTDATA = 'SET_AMENDMENTDATA';
const FETCH_AMENDMENT_DATA = 'FETCH_AMENDMENT_DATA';
const UPDATE_AMENDMENT_DATA = 'UPDATE_AMENDMENT_DATA';
const SAVE_AMENDMENT_DATA = 'SAVE_AMENDMENT_DATA';
// Add other action types as needed

// Action Creators
export const setContracts = (contracts) => ({
  type: SET_CONTRACTS,
  payload: contracts,
});

export const setStep = (step) => ({
  type: SET_STEP,
  payload: step,
});

export const setFormId = (formId) => ({
  type: SET_FORMID,
  payload: formId,
}); 

export const setAmendmentId = (amendmentId) => ({
  type: SET_AMENDMENTID,
  payload: amendmentId,
}); 

export const setFullForm = (fullForm) => ({
  type: SET_FULLFORM,
  payload: fullForm,
}); 

export const setAmendmentData = (amendmentData) => ({
  type: SET_AMENDMENTDATA,
  payload: amendmentData,
}); 

export const fetchAmendmentData = (amendmentId, amendmentData) => ({
  type: FETCH_AMENDMENT_DATA, 
  payload: { amendmentId, amendmentData}
}); 

export const updateAmendmentData = (amendmentId, amendmentData) => ({
  type: UPDATE_AMENDMENT_DATA, 
  payload: { amendmentId, amendmentData}
}); 

export const saveAmendmentData = (formId, amendmentData) => ({
  type: SAVE_AMENDMENT_DATA, 
  payload: { formId, amendmentData}
}); 